import { isDayInFuture, toISODateOnly } from '../../../../utils/dateUtils';
import {
  TimeBalanceSettingsFragment,
  TimeFrameworkFragment,
  TimeLimitSettingsFragment,
  TimeTrackingSettings_WorkloadFieldsFragment,
  useTimeTrackingSettingsQuery,
  WorkloadWeekFragment,
} from '../../__generated__/graphql';
import { useTimeTrackingContext } from './TimeTrackingContext';

export type TimeTrackingSettings = {
  workload: TimeTrackingSettings_WorkloadFieldsFragment | null;
  workloadWeek: WorkloadWeekFragment | null;
  timeFramework: TimeFrameworkFragment | null;
  timeBalanceSettings: TimeBalanceSettingsFragment | null;
  timeLimitSettings: TimeLimitSettingsFragment | null;
};

export const useTimeTrackingSettings = (): TimeTrackingSettings & {
  loading: boolean;
} => {
  const { employeeId } = useTimeTrackingContext();
  const now = new Date();
  const today = toISODateOnly(now);

  const { data, loading } = useTimeTrackingSettingsQuery({
    variables: {
      employeeId,
      today,
    },
  });

  const workload = data?.workloads?.[0];

  return {
    ...mapTimeTrackingSettings(workload ?? null),
    loading,
  };
};

export const useRestrictFutureEntries = () => {
  const { timeLimitSettings } = useTimeTrackingSettings();

  const shouldRestrictFutureEntries =
    timeLimitSettings?.flair__Is_Restrict_Future_Entries_Enabled__c === true;
  return {
    shouldRestrictFutureEntries,
    restrictFutureEntriesForADay: (date: Date): boolean => {
      const today = new Date();
      return shouldRestrictFutureEntries && isDayInFuture(today, date);
    },
  };
};

export const mapTimeTrackingSettings = (
  workload: TimeTrackingSettings_WorkloadFieldsFragment | null,
): TimeTrackingSettings => ({
  workload: workload ?? null,
  workloadWeek: workload?.workloadWeeks?.[0] ?? null,
  timeFramework: workload?.timeFramework ?? null,
  timeBalanceSettings: workload?.timeFramework?.timeBalanceSettings ?? null,
  timeLimitSettings: workload?.timeFramework?.timeLimitSettings ?? null,
});
